import React from "react";
import classNames from "classnames";

import NavContainer from "../../containers/nav";
import SideBarContainer from "../../containers/sidebar";
import createErrorBoundary from "shared/components/wrappers/errorBoundary";

const ErrorBoundedSideBarContainer =
  createErrorBoundary(true)(SideBarContainer);

class AppContentWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { currentContractor } = this.props;

    const primaryContainerClasses = classNames({
      "primary-content-container": currentContractor != null,
      "grey-background": true,
    });

    const sidebarClasses = classNames({
      "disabled-sidebar": true,
      "collapsed-sidebar": false,
      "shared-sidebar": false,
    });

    return (
      <div className={sidebarClasses}>
        {currentContractor != null && <ErrorBoundedSideBarContainer />}
        <NavContainer isShared={true} />
        <div className={primaryContainerClasses}>{this.props.children}</div>
      </div>
    );
  }
}

export default AppContentWrapper;
